<template>
    <div class="details">
        <div class="box80">
            <div class="wid100">
                <div class="details_l">
                    <div class="details_l_t">
                        <div class="cont">
                            <!-- <button class="fanhuo" @click="back()"><span><i class="el-icon-back"></i></span>返回</button> -->
                            <el-popover placement="right" trigger="click" class="list_S" v-model="detailsShow" popper-class="details-class">
                                <el-button size="mini" type="text" @click="detailsShow = false" icon="el-icon-error"></el-button>
                                <div class="tp">选择设置项包含的信息</div>
                                <div class="contcheck">
                                    <div class="ser">
                                        
                                        <div v-for="(item,index)  in columnShowHideList" :key="index" class="li_list" >
                                            <input :checked="item.value ? 'checked' : ''" :name="'checkbox'+index" @click="changeColumnSH(index,item)" type="checkbox"/>
                                            <span >{{item.label}}</span>
                                        </div>
                                    </div>    
                                        <div class="btn">
                                            <el-button type="primary"  @click="detailsShow = false">确定</el-button>
                                        </div>
                                   
                                </div>
                                <el-button slot="reference"><img src="@/assets/images/icon9_271.png" alt="">设置对比参数</el-button>
                            </el-popover>

                            <button  @click="hideXiangTong" ><img src="@/assets/images/icon12_06.png" alt="">隐藏相同参数</button>
                        </div>
                        <div class="xian"></div> 
                        <div class="cont">
                            <el-radio v-model="radio" label="1">查看全部</el-radio>
                            <el-radio v-model="radio" label="2">查看实测数据</el-radio>
                            <el-radio v-model="radio" label="3">查看标称数据</el-radio>
                            <el-checkbox v-if="!checkab && (dian==17||dian==29)" v-model="checkab">查看B面数据</el-checkbox>
                            <el-checkbox v-if="checkab && (dian==17||dian==29)" v-model="checkab">查看A面数据</el-checkbox>
                            <div class="tab"  v-if="dian != 31">
                                <span>图片切换 :</span>
                                <span><img @click="showPseuColor=false" src="@/assets/images/icon6_21.jpg" alt=""></span>
                                <span><img @click="showPseuColor=true" src="@/assets/images/icon7_23.jpg" alt=""></span>
                            </div>
                        </div>
                    </div>
                    <div class="details_l_b">
                        <ul v-if="dian == 31">
                            <li v-if="columnShowHideList[0].value">应用面类型</li>
                            <li v-if="columnShowHideList[1].value">被照面信息</li>
                            <li v-if="columnShowHideList[2].value">反射率</li>
                            <li v-if="columnShowHideList[3].value">数据来源</li>
                            <li v-if="columnShowHideList[4].value">品牌名称</li>
                            <li v-if="columnShowHideList[5].value">灯具类型</li>
                            <li v-if="columnShowHideList[6].value">设计编号</li>
                            <li v-if="columnShowHideList[7].value">样品名称</li>
                            <li v-if="columnShowHideList[8].value">光源类型</li>
                            <li v-if="columnShowHideList[9].value">标称功率(W)</li>
                            <li v-if="columnShowHideList[10].value">标称电压(V)</li>
                            <li v-if="columnShowHideList[11].value">标称色温(K/nm)</li>
                            <li v-if="columnShowHideList[12].value">标称光束角</li>
                            <li v-if="columnShowHideList[13].value">灯具尺寸(含支架mm)</li>
                            <li v-if="columnShowHideList[14].value">灯具尺寸(不含支架mm)</li>
                            <li v-if="columnShowHideList[15].value">检测模式</li>
                            <li v-if="columnShowHideList[16].value">实测功率(W)</li>
                            <li v-if="columnShowHideList[17].value">功率因数</li>
                            <li v-if="columnShowHideList[18].value">实测电压(V)</li>
                            <li v-if="columnShowHideList[19].value">实测光束角</li>
                            <li v-if="columnShowHideList[20].value">实测色温(K/nm)</li>
                            <li v-if="columnShowHideList[21].value">色容差(SDCM)</li>
                            <li v-if="columnShowHideList[22].value">Ra</li>
                            <li v-if="columnShowHideList[23].value">R9</li>
                            <li v-if="columnShowHideList[24].value">光通量(lm)</li>
                            <!-- <li v-if="columnShowHideList[25].value" style="display:none">峰值光强(cd)</li> -->
                            <li v-if="columnShowHideList[26].value">0°(cd)</li>
                            <li v-if="columnShowHideList[27].value">下10° 右60°(cd)</li>
                            <li v-if="columnShowHideList[28].value">右60°(cd)</li>
                            <li v-if="columnShowHideList[29].value">下45°(cd) </li>
                            <li v-if="columnShowHideList[30].value">下60°(cd)</li>
                            <li v-if="columnShowHideList[31].value">左60°(cd)</li>
                            <li v-if="columnShowHideList[32].value">上30°(cd)</li>
                            <li v-if="columnShowHideList[33].value">下10°(cd)</li>
                            <li v-if="columnShowHideList[34].value">上60°(cd)</li>
                            <li v-if="columnShowHideList[35].value">下10° 左60°(cd)</li>
                            <li v-if="columnShowHideList[36].value">测试角度</li>
                            <li v-if="columnShowHideList[37].value">含灯距离(m)</li>
                            <li v-if="columnShowHideList[38].value">平均亮度(cd/㎡)</li>
                            <li v-if="columnShowHideList[39].value">最大亮度(cd/㎡)</li>
                            <li v-if="columnShowHideList[40].value">最小亮度(cd/㎡)</li>
                            <li v-if="columnShowHideList[41].value">均匀度</li>
                            <li v-if="columnShowHideList[42].value">暗斑高度(m)</li>
                            <li v-if="columnShowHideList[43].value">IP等级</li>
                            <li v-if="columnShowHideList[44].value">防盐雾</li>
                            <li v-if="columnShowHideList[45].value">价格(元)</li>
                        </ul>
                        <ul v-else-if="dian==17 || dian ==29">
                            <li v-if="columnShowHideList[0].value">应用面类型</li>
                            <li v-if="columnShowHideList[1].value">应用面信息(m)</li>
                            <li v-if="columnShowHideList[2].value">反射率</li>
                            <li v-if="columnShowHideList[3].value">数据来源</li>
                            <li v-if="columnShowHideList[4].value">品牌名称</li>
                            <li v-if="columnShowHideList[5].value">灯具类型</li>
                            <li v-if="columnShowHideList[6].value">设计编号</li>
                            <li v-if="columnShowHideList[7].value">样品名称</li>
                            <li v-if="columnShowHideList[8].value">光源类型</li>
                            <li v-if="columnShowHideList[9].value">标称功率(W)</li>
                            <li v-if="columnShowHideList[10].value">标称电压(V)</li>
                            <li v-if="columnShowHideList[11].value">标称色温(K/nm)</li>
                            <li v-if="columnShowHideList[12].value">标称光束角</li>
                            <li v-if="columnShowHideList[13].value">灯具尺寸(含支架mm)</li>
                            <li v-if="columnShowHideList[14].value">灯具尺寸(不含支架mm)</li>
                            <li v-if="columnShowHideList[15].value">检测模式</li>
                            <li v-if="columnShowHideList[16].value">实测功率(W)</li>
                            <li v-if="columnShowHideList[17].value">功率因数</li>
                            <li v-if="columnShowHideList[18].value">实测电压(V)</li>
                            <li v-if="columnShowHideList[19].value">实测光束角</li>
                            <li v-if="columnShowHideList[20].value">实测色温(K/nm)</li>
                            <li v-if="columnShowHideList[21].value">色容差(SDCM)</li>
                            <li v-if="columnShowHideList[22].value">Ra</li>
                            <li v-if="columnShowHideList[23].value">R9</li>
                            <li v-if="columnShowHideList[24].value">光通量(lm)</li>
                            <!-- <li v-if="columnShowHideList[25].value" style="display:none">峰值光强(cd)</li> -->
                            <li v-if="columnShowHideList[26].value">测试角度</li>
                            <li v-if="columnShowHideList[27].value">含灯距离(m)</li>
                            <li v-if="columnShowHideList[28].value">平均亮度(cd/㎡)</li>
                            <li v-if="columnShowHideList[29].value">最大亮度(cd/㎡)</li>
                            <li v-if="columnShowHideList[30].value">最小亮度(cd/㎡)</li>
                            <li v-if="columnShowHideList[31].value">均匀度</li>
                            <li v-if="columnShowHideList[32].value">暗斑高度(m)</li>
                            <li v-if="columnShowHideList[33].value">IP等级</li>
                            <li v-if="columnShowHideList[34].value">防盐雾</li>
                            <li v-if="columnShowHideList[35].value">价格(元)</li>
                            <li v-if="columnShowHideList[36].value">测试面（A/B）</li>
                        </ul>
                        <ul v-else>
                            <li v-if="columnShowHideList[0].value">应用面类型</li>
                            <li v-if="columnShowHideList[1].value">应用面信息(m)</li>
                            <li v-if="columnShowHideList[2].value">反射率</li>
                            <li v-if="columnShowHideList[3].value">数据来源</li>
                            <li v-if="columnShowHideList[4].value">品牌名称</li>
                            <li v-if="columnShowHideList[5].value">灯具类型</li>
                            <li v-if="columnShowHideList[6].value">设计编号</li>
                            <li v-if="columnShowHideList[7].value">样品名称</li>
                            <li v-if="columnShowHideList[8].value">光源类型</li>
                            <li v-if="columnShowHideList[9].value">标称功率(W)</li>
                            <li v-if="columnShowHideList[10].value">标称电压(V)</li>
                            <li v-if="columnShowHideList[11].value">标称色温(K/nm)</li>
                            <li v-if="columnShowHideList[12].value">标称光束角</li>
                            <li v-if="columnShowHideList[13].value">灯具尺寸(含支架mm)</li>
                            <li v-if="columnShowHideList[14].value">灯具尺寸(不含支架mm)</li>
                            <li v-if="columnShowHideList[15].value">检测模式</li>
                            <li v-if="columnShowHideList[16].value">实测功率(W)</li>
                            <li v-if="columnShowHideList[17].value">功率因数</li>
                            <li v-if="columnShowHideList[18].value">实测电压(V)</li>
                            <li v-if="columnShowHideList[19].value">实测光束角</li>
                            <li v-if="columnShowHideList[20].value">实测色温(K/nm)</li>
                            <li v-if="columnShowHideList[21].value">色容差(SDCM)</li>
                            <li v-if="columnShowHideList[22].value">Ra</li>
                            <li v-if="columnShowHideList[23].value">R9</li>
                            <li v-if="columnShowHideList[24].value">光通量(lm)</li>
                            <!-- <li v-if="columnShowHideList[25].value" style="display:none">峰值光强(cd)</li> -->
                            <li v-if="columnShowHideList[26].value">测试角度</li>
                            <li v-if="columnShowHideList[27].value">含灯距离(m)</li>
                            <li v-if="columnShowHideList[28].value">平均亮度(cd/㎡)</li>
                            <li v-if="columnShowHideList[29].value">最大亮度(cd/㎡)</li>
                            <li v-if="columnShowHideList[30].value">最小亮度(cd/㎡)</li>
                            <li v-if="columnShowHideList[31].value">均匀度</li>
                            <li v-if="columnShowHideList[32].value">暗斑高度(m)</li>
                            <li v-if="columnShowHideList[33].value">IP等级</li>
                            <li v-if="columnShowHideList[34].value">防盐雾</li>
                            <li v-if="columnShowHideList[35].value">价格(元)</li>
                        </ul>
                    </div>
                </div>
                <!--查看图片 -->
                <el-dialog :visible.sync="showPic" v-dialogDrag custom-class="imgsAMG dee">
                <span><img :src="showPicUrl" /></span>
                </el-dialog>
                <div class="details_r">
                    <div class="details_r_list" v-for="item in tableData" :key="item.id">
                        <div class="details_r_t">
                            <div class="conts">
                                <span v-if="dian == 31">
                                    <img @click="viewPicture(ImgPath+item.lightIntensity)" :src="ImgPath+item.lightIntensity" class="imhs" alt="">
                                </span>
                                <span v-else>
                                    <img @click="viewPicture(ImgPath+item.pseuColor)" v-if="showPseuColor" :src="ImgPath+item.pseuColor" class="imhs" alt="">
                                    <img @click="viewPicture(ImgPath+item.viewPhoto)" v-if="!showPseuColor" :src="ImgPath+item.viewPhoto" class="imhs" alt="">
                                </span>
                            </div>
                        </div>
                        <div class="details_r_b">
                            <ul v-if="dian==31">
                                <li v-if="columnShowHideList[0].value">{{item.contestTypeStr}}</li>
                                <li v-if="columnShowHideList[1].value">
                                    <span v-show="item.h != null">H：{{item.h}}</span> &nbsp; <span v-show="item.w != null">W：{{item.w}}</span> &nbsp; <span v-show="item.w1 != null">W1：{{item.w1}} </span> &nbsp; <span v-show="item.w2 != null">W2：{{item.w2}}</span>
                                </li>
                                <li v-if="columnShowHideList[2].value">{{item.albedo}}</li>
                                <li v-if="columnShowHideList[3].value">
                                    <span v-if="item.dataType == 1">典型检测</span>
                                    <span v-if="item.dataType == 2">项目检测</span>
                                </li>
                                <li v-if="columnShowHideList[4].value">{{item.brandName}}</li>
                                <li v-if="columnShowHideList[5].value">{{item.dictIdLtype}}</li>
                                <li v-if="columnShowHideList[6].value">{{item.designCode}}</li>
                                <li v-if="columnShowHideList[7].value">{{item.lumName}}</li>
                                <li v-if="columnShowHideList[8].value">{{item.dictIdLitype}}</li>
                                <li v-if="columnShowHideList[9].value">{{item.lumPower}}</li>
                                <li v-if="columnShowHideList[10].value">{{item.lumVoltage}}</li>
                                <li v-if="columnShowHideList[11].value">{{item.lumColorTempe}}</li>
                                <li v-if="columnShowHideList[12].value">{{item.lumAngle}}</li>
                                <li v-if="columnShowHideList[13].value">
                                    <span v-if="item.longS != null || item.widthS != null || item.heightS != null">{{item.longS}}*{{item.widthS}}*{{item.heightS}}</span>
                                </li>
                                <li v-if="columnShowHideList[14].value">
                                    <span v-if="item.longNs != null || item.widthNs != null || item.heightNs != null">{{item.longNs}}*{{item.widthNs}}*{{item.heightNs}}</span>
                                </li>
                                <li v-if="columnShowHideList[15].value">{{item.rgbwa}}</li>
                                <li v-if="columnShowHideList[16].value">{{item.power}}</li>
                                <li v-if="columnShowHideList[17].value">{{item.powerFactor}}</li>
                                <li v-if="columnShowHideList[18].value">{{item.voltage}}</li>
                                <li v-if="columnShowHideList[19].value">
                                    <span v-if="item.angle1 != null || item.angle2 != null">{{item.angle1}}*{{item.angle2}}</span>
                                </li>
                                <li v-if="columnShowHideList[20].value">{{item.colorTempe}}</li>
                                <li v-if="columnShowHideList[21].value">{{item.sdcm}}</li>
                                <li v-if="columnShowHideList[22].value">{{item.colorXszs}}</li>
                                <li v-if="columnShowHideList[23].value">{{item.colorXszsR9}}</li>
                                <li v-if="columnShowHideList[24].value">{{item.opticGtl}}</li>
                                <!-- <li v-if="columnShowHideList[25].value">{{item.lightFzgq}}</li> -->
                                <li v-if="columnShowHideList[26].value">{{item.lightIntensity1}}</li>
                                <li v-if="columnShowHideList[27].value">{{item.lightIntensity10}}</li>
                                <li v-if="columnShowHideList[28].value">{{item.lightIntensity2}}</li>
                                <li v-if="columnShowHideList[29].value">{{item.lightIntensity3}}</li>
                                <li v-if="columnShowHideList[30].value">{{item.lightIntensity4}}</li>
                                <li v-if="columnShowHideList[31].value">{{item.lightIntensity5}}</li>
                                <li v-if="columnShowHideList[32].value">{{item.lightIntensity6}}</li>
                                <li v-if="columnShowHideList[33].value">{{item.lightIntensity7}}</li>
                                <li v-if="columnShowHideList[34].value">{{item.lightIntensity8}}</li>
                                <li v-if="columnShowHideList[35].value">{{item.lightIntensity9}}</li>
                                <li v-if="columnShowHideList[36].value">{{item.testAngle}}</li>
                                <li v-if="columnShowHideList[37].value">{{item.lumSize}}</li>
                                <li v-if="columnShowHideList[38].value">{{item.lightnessAve}}</li>
                                <li v-if="columnShowHideList[39].value">{{item.lightnessMax}}</li>
                                <li v-if="columnShowHideList[40].value">{{item.lightness}}</li>
                                <li v-if="columnShowHideList[41].value">{{item.evenness}}</li>
                                <li v-if="columnShowHideList[42].value">{{item.anbanHeight}}</li>
                                <li v-if="columnShowHideList[43].value">
                                    <span v-if="item.anWater != null">{{item.anWater == 'P' ? item.ipGrade : item.anWater != null ? item.anWater : '-'}}</span>
                                </li>
                                <li v-if="columnShowHideList[44].value">{{item.anSaltfog}}</li>
                                <li v-if="columnShowHideList[45].value">{{item.authorizedPrice}}</li>
                            </ul>
                            <ul v-else-if="dian==17||dian==29">
                                <li v-if="columnShowHideList[0].value">{{item.contestTypeStr}}</li>
                               <li v-if="columnShowHideList[1].value">
                                    <span v-show="item.h != null">H：{{item.h}}</span> &nbsp; <span v-show="item.w != null">W：{{item.w}}</span> &nbsp; <span v-show="item.w1 != null">W1：{{item.w1}} </span> &nbsp; <span v-show="item.w2 != null">W2：{{item.w2}}</span>
                                </li>
                                <li v-if="columnShowHideList[2].value">{{item.albedo}}</li>
                                <li v-if="columnShowHideList[3].value">
                                    <span v-if="item.dataType == 1">典型检测</span>
                                    <span v-if="item.dataType == 2">项目检测</span>
                                </li>
                                <li v-if="columnShowHideList[4].value">{{item.brandName}}</li>
                                <li v-if="columnShowHideList[5].value">{{item.dictIdLtype}}</li>
                                <li v-if="columnShowHideList[6].value">{{item.designCode}}</li>
                                <li v-if="columnShowHideList[7].value">{{item.lumName}}</li>
                                <li v-if="columnShowHideList[8].value">{{item.dictIdLitype}}</li>
                                <li v-if="columnShowHideList[9].value">{{item.lumPower}}</li>
                                <li v-if="columnShowHideList[10].value">{{item.lumVoltage}}</li>
                                <li v-if="columnShowHideList[11].value">{{item.lumColorTempe}}</li>
                                <li v-if="columnShowHideList[12].value">{{item.lumAngle}}</li>
                               <li v-if="columnShowHideList[13].value">
                                    <span v-if="item.longS != null || item.widthS != null || item.heightS != null">{{item.longS}}*{{item.widthS}}*{{item.heightS}}</span>
                                </li>
                                <li v-if="columnShowHideList[14].value">
                                    <span v-if="item.longNs != null || item.widthNs != null || item.heightNs != null">{{item.longNs}}*{{item.widthNs}}*{{item.heightNs}}</span>
                                </li>
                                <li v-if="columnShowHideList[15].value">{{item.rgbwa}}</li>
                                <li v-if="columnShowHideList[16].value">{{item.power}}</li>
                                <li v-if="columnShowHideList[17].value">{{item.powerFactor}}</li>
                                <li v-if="columnShowHideList[18].value">{{item.voltage}}</li>
                                <li v-if="columnShowHideList[19].value">
                                    <span v-if="item.angle1 != null || item.angle2 != null">{{item.angle1}}*{{item.angle2}}</span>
                                </li>
                                <li v-if="columnShowHideList[20].value">{{item.colorTempe}}</li>
                                <li v-if="columnShowHideList[21].value">{{item.sdcm}}</li>
                                <li v-if="columnShowHideList[22].value">{{item.colorXszs}}</li>
                                <li v-if="columnShowHideList[23].value">{{item.colorXszsR9}}</li>
                                <li v-if="columnShowHideList[24].value">{{item.opticGtl}}</li>
                                <!-- <li v-if="columnShowHideList[25].value">{{item.lightFzgq}}</li> -->
                                <li v-if="columnShowHideList[26].value">{{item.testAngle}}</li>
                                <li v-if="columnShowHideList[27].value">{{item.lumSize}}</li>
                                <li v-if="columnShowHideList[28].value">{{item.lightnessAve}}</li>
                                <li v-if="columnShowHideList[29].value">{{item.lightnessMax}}</li>
                                <li v-if="columnShowHideList[30].value">{{item.lightness}}</li>
                                <li v-if="columnShowHideList[31].value">{{item.evenness}}</li>
                                <li v-if="columnShowHideList[32].value">{{item.anbanHeight}}</li>
                                
                                <li v-if="columnShowHideList[33].value">
                                    <span v-if="item.anWater != null">{{item.anWater == 'P' ? item.ipGrade : item.anWater != null ? item.anWater : '-'}}</span>
                                </li>
                                <li v-if="columnShowHideList[34].value">{{item.anSaltfog}}</li>
                                <li v-if="columnShowHideList[35].value">{{item.authorizedPrice}}</li>
                                <li v-if="columnShowHideList[36].value">{{item.surfaceType}}</li>
                            </ul>
                            <ul v-else>
                                <li v-if="columnShowHideList[0].value">{{item.contestTypeStr}}</li>
                                <li v-if="columnShowHideList[1].value">
                                    <span v-show="item.h != null">H：{{item.h}}</span> &nbsp; <span v-show="item.w != null">W：{{item.w}}</span> &nbsp; <span v-show="item.w1 != null">W1：{{item.w1}} </span> &nbsp; <span v-show="item.w2 != null">W2：{{item.w2}}</span>
                                </li>
                                <li v-if="columnShowHideList[2].value">{{item.albedo}}</li>
                                <li v-if="columnShowHideList[3].value">
                                    <span v-if="item.dataType == 1">典型检测</span>
                                    <span v-if="item.dataType == 2">项目检测</span>
                                </li>
                                <li v-if="columnShowHideList[4].value">{{item.brandName}}</li>
                                <li v-if="columnShowHideList[5].value">{{item.dictIdLtype}}</li>
                                <li v-if="columnShowHideList[6].value">{{item.designCode}}</li>
                                <li v-if="columnShowHideList[7].value">{{item.lumName}}</li>
                                <li v-if="columnShowHideList[8].value">{{item.dictIdLitype}}</li>
                                <li v-if="columnShowHideList[9].value">{{item.lumPower}}</li>
                                <li v-if="columnShowHideList[10].value">{{item.lumVoltage}}</li>
                                <li v-if="columnShowHideList[11].value">{{item.lumColorTempe}}</li>
                                <li v-if="columnShowHideList[12].value">{{item.lumAngle}}</li>
                                <li v-if="columnShowHideList[13].value">
                                    <span v-if="item.longS != null || item.widthS != null || item.heightS != null">{{item.longS}}*{{item.widthS}}*{{item.heightS}}</span>
                                </li>
                                <li v-if="columnShowHideList[14].value">
                                    <span v-if="item.longNs != null || item.widthNs != null || item.heightNs != null">{{item.longNs}}*{{item.widthNs}}*{{item.heightNs}}</span>
                                </li>
                                <li v-if="columnShowHideList[15].value">{{item.rgbwa}}</li>
                                <li v-if="columnShowHideList[16].value">{{item.power}}</li>
                                <li v-if="columnShowHideList[17].value">{{item.powerFactor}}</li>
                                <li v-if="columnShowHideList[18].value">{{item.voltage}}</li>
                                <li v-if="columnShowHideList[19].value">
                                    <span v-if="item.angle1 != null || item.angle2 != null">{{item.angle1}}*{{item.angle2}}</span>
                                </li>
                                <li v-if="columnShowHideList[20].value">{{item.colorTempe}}</li>
                                <li v-if="columnShowHideList[21].value">{{item.sdcm}}</li>
                                <li v-if="columnShowHideList[22].value">{{item.colorXszs}}</li>
                                <li v-if="columnShowHideList[23].value">{{item.colorXszsR9}}</li>
                                <li v-if="columnShowHideList[24].value">{{item.opticGtl}}</li>
                                <!-- <li v-if="columnShowHideList[25].value">{{item.lightFzgq}}</li> -->
                                <li v-if="columnShowHideList[26].value">{{item.testAngle}}</li>
                                <li v-if="columnShowHideList[27].value">{{item.lumSize}}</li>
                                <li v-if="columnShowHideList[28].value">{{item.lightnessAve}}</li>
                                <li v-if="columnShowHideList[29].value">{{item.lightnessMax}}</li>
                                <li v-if="columnShowHideList[30].value">{{item.lightness}}</li>
                                <li v-if="columnShowHideList[31].value">{{item.evenness}}</li>
                                <li v-if="columnShowHideList[32].value">{{item.anbanHeight}}</li>
                                <li v-if="columnShowHideList[33].value">
                                    <span v-if="item.anWater != null">{{item.anWater == 'P' ? item.ipGrade : item.anWater != null ? item.anWater : '-'}}</span>
                                </li>
                                <li v-if="columnShowHideList[34].value">{{item.anSaltfog}}</li>
                                <li v-if="columnShowHideList[35].value">{{item.authorizedPrice}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            checkab:false,
            showPic:false, //查看图片
            showPicUrl:'', //图片地址
            radio: '1',
            detailsShow:false,
            showPseuColor:false, //切换图片
            tableData:[],
            dian:true,
            columnShowHideList:[],
        }
    },
    created(){
        this.initData()

        //延迟查询
        this.timer = setTimeout(() => {
            this.hideXiangTong();
        }, 1500)

        //this.hideXiangTong();
    },
    watch:{
        checkab:function(val,old){
            this.initData()
        },
        radio:function(val,old){
            if(val == "1"){
                this.checkAll();
            }else if(val == "2"){
                this.checkShiCe();
            }else if(val == "3"){
                this.checkBiaocheng();
            }else{
                // this.checkAll();
            }
        }
    },
    methods:{
        viewPicture(url){
            this.showPic = true
            this.showPicUrl = url
        },
        checkAll(){
            if(this.dian == 31){//点光源
                this.columnShowHideList = [
                        {
                            label:'应用面类型',
                            value:true
                        },
                        {
                            label:'被照面信息',
                            value:true
                        },
                        {
                            label:'反射率',
                            value:true
                        },
                        {
                            label:'数据来源',
                            value:true
                        },
                        {
                            label:'品牌名称',
                            value:true
                        },
                        {
                            label:'灯具类型',
                            value:true
                        },
                        {
                            label:'设计编号',
                            value:true
                        },
                        {
                            label:'样品名称',
                            value:true
                        },
                        {
                            label:'光源类型',
                            value:true
                        },
                        {
                            label:'标称功率(W)',
                            value:true
                        },
                        {
                            label:'标称电压(V)',
                            value:true
                        },
                        {
                            label:'标称色温(K/nm)',
                            value:true
                        },
                        {
                            label:'标称光束角',
                            value:true
                        },
                        {
                            label:'灯具尺寸(含支架mm)',
                            value:true
                        },
                        {
                            label:'灯具尺寸(不含支架mm)',
                            value:true
                        },
                        {
                            label:'检测模式',
                            value:true
                        },
                        {
                            label:'实测功率(W)',
                            value:true
                        },
                        {
                            label:'功率因数',
                            value:true
                        },
                        {
                            label:'实测电压(V)',
                            value:true
                        },
                        {
                            label:'实测光束角',
                            value:true
                        },
                        {
                            label:'实测色温(K/nm)',
                            value:true
                        },
                        {
                            label:'色容差(SDCM)',
                            value:true
                        },
                        {
                            label:'Ra',
                            value:true
                        },
                        {
                            label:'R9',
                            value:true
                        },
                        {
                            label:'光通量(lm)',
                            value:true
                        },
                        {
                            label:'峰值光强(cd)',
                            value:true
                        },
                        {
                            label:'0°(cd)',
                            value:true
                        },
                        {
                            label:'下10° 右60°(cd)',
                            value:true
                        },
                        {
                            label:'右60°(cd)',
                            value:true
                        },
                        {
                            label:'下45°(cd)',
                            value:true
                        },
                        {
                            label:'下60°(cd)',
                            value:true
                        },
                        {
                            label:'左60°(cd)',
                            value:true
                        },
                        {
                            label:'上30°(cd)',
                            value:true
                        },
                        {
                            label:'下10°(cd)',
                            value:true
                        },
                        {
                            label:'上60°(cd)',
                            value:true
                        },
                        {
                            label:'下10° 左60°(cd)',
                            value:true
                        },
                        {
                            label:'测试角度',
                            value:false
                        },
                        {
                            label:'含灯距离(m)',
                            value:false
                        },
                        {
                            label:'平均亮度(cd/㎡)',
                            value:false
                        },
                        {
                            label:'最大亮度(cd/㎡)',
                            value:false
                        },
                        {
                            label:'最小亮度(cd/㎡)',
                            value:false
                        },
                        {
                            label:'均匀度',
                            value:false
                        },
                        {
                            label:'暗斑高度(m)',
                            value:false
                        },
                        {
                            label:'IP等级',
                            value:true
                        },
                        {
                            label:'防盐雾',
                            value:true
                        },
                        {
                            label:'价格(元)',
                            value:true
                        },
                    ]
                
            }else if(this.dian == 17 || this.dian == 29){
                this.columnShowHideList = [ 
                    {
                        label:'应用面类型',
                        value:true
                    },
                    {
                        label:'被照面信息',
                        value:true
                    },
                    {
                        label:'反射率',
                        value:true
                    },
                    {
                        label:'数据来源',
                        value:true
                    },
                    {
                        label:'品牌名称',
                        value:true
                    },
                    {
                        label:'灯具类型',
                        value:true
                    },
                    {
                        label:'设计编号',
                        value:true
                    },
                    {
                        label:'样品名称',
                        value:true
                    },
                    {
                        label:'光源类型',
                        value:true
                    },
                    {
                        label:'标称功率(W)',
                        value:true
                    },
                    {
                        label:'标称电压(V)',
                        value:true
                    },
                    {
                        label:'标称色温(K/nm)',
                        value:true
                    },
                    {
                        label:'标称光束角',
                        value:true
                    },
                    {
                        label:'灯具尺寸(含支架mm)',
                        value:true
                    },
                    {
                        label:'灯具尺寸(不含支架mm)',
                        value:true
                    },
                    {
                        label:'检测模式',
                        value:true
                    },
                    {
                        label:'实测功率(W)',
                        value:true
                    },
                    {
                        label:'功率因数',
                        value:true
                    },
                    {
                        label:'实测电压(V)',
                        value:true
                    },
                    {
                        label:'实测光束角',
                        value:true
                    },
                    {
                        label:'实测色温(K/nm)',
                        value:true
                    },
                    {
                        label:'色容差(SDCM)',
                        value:true
                    },
                    {
                        label:'Ra',
                        value:true
                    },
                    {
                        label:'R9',
                        value:true
                    },
                    {
                        label:'光通量(lm)',
                        value:true
                    },
                    {
                        label:'峰值光强(cd)',
                        value:true
                    },
                    {
                        label:'测试角度',
                        value:true
                    },
                    {
                        label:'含灯距离(m)',
                        value:true
                    },
                    {
                        label:'平均亮度(cd/㎡)',
                        value:true
                    },
                    {
                        label:'最大亮度(cd/㎡)',
                        value:true
                    },
                    {
                        label:'最小亮度(cd/㎡)',
                        value:true
                    },
                    {
                        label:'均匀度',
                        value:true
                    },
                    {
                        label:'暗斑高度(m)',
                        value:true
                    },
                    {
                        label:'IP等级',
                        value:true
                    },
                    {
                        label:'防盐雾',
                        value:true
                    },
                    {
                        label:'价格(元)',
                        value:true
                    },
                    {
                        label:'测试面（A/B）',
                        value:true
                    }
                ]
            }else{
                this.columnShowHideList = [ 
                    {
                        label:'应用面类型',
                        value:true
                    },
                    {
                        label:'被照面信息',
                        value:true
                    },
                    {
                        label:'反射率',
                        value:true
                    },
                    {
                        label:'数据来源',
                        value:true
                    },
                    {
                        label:'品牌名称',
                        value:true
                    },
                    {
                        label:'灯具类型',
                        value:true
                    },
                    {
                        label:'设计编号',
                        value:true
                    },
                    {
                        label:'样品名称',
                        value:true
                    },
                    {
                        label:'光源类型',
                        value:true
                    },
                    {
                        label:'标称功率(W)',
                        value:true
                    },
                    {
                        label:'标称电压(V)',
                        value:true
                    },
                    {
                        label:'标称色温(K/nm)',
                        value:true
                    },
                    {
                        label:'标称光束角',
                        value:true
                    },
                    {
                        label:'灯具尺寸(含支架mm)',
                        value:true
                    },
                    {
                        label:'灯具尺寸(不含支架mm)',
                        value:true
                    },
                    {
                        label:'检测模式',
                        value:true
                    },
                    {
                        label:'实测功率(W)',
                        value:true
                    },
                    {
                        label:'功率因数',
                        value:true
                    },
                    {
                        label:'实测电压(V)',
                        value:true
                    },
                    {
                        label:'实测光束角',
                        value:true
                    },
                    {
                        label:'实测色温(K/nm)',
                        value:true
                    },
                    {
                        label:'色容差(SDCM)',
                        value:true
                    },
                    {
                        label:'Ra',
                        value:true
                    },
                    {
                        label:'R9',
                        value:true
                    },
                    {
                        label:'光通量(lm)',
                        value:true
                    },
                    {
                        label:'峰值光强(cd)',
                        value:true
                    },
                    {
                        label:'测试角度',
                        value:true
                    },
                    {
                        label:'含灯距离(m)',
                        value:true
                    },
                    {
                        label:'平均亮度(cd/㎡)',
                        value:true
                    },
                    {
                        label:'最大亮度(cd/㎡)',
                        value:true
                    },
                    {
                        label:'最小亮度(cd/㎡)',
                        value:true
                    },
                    {
                        label:'均匀度',
                        value:true
                    },
                    {
                        label:'暗斑高度(m)',
                        value:true
                    },
                    {
                        label:'IP等级',
                        value:true
                    },
                    {
                        label:'防盐雾',
                        value:true
                    },
                    {
                        label:'价格(元)',
                        value:true
                    }
                ]
            }
        },
        checkShiCe(){
            if(this.dian == 31){
               this.columnShowHideList = [
                {
                    label:'应用面类型',
                    value:true
                },
                {
                    label:'被照面信息',
                    value:true
                },
                {
                    label:'反射率',
                    value:true
                },
                {
                    label:'数据来源',
                    value:true
                },
                {
                    label:'品牌名称',
                    value:true
                },
                {
                    label:'灯具类型',
                    value:true
                },
                {
                    label:'设计编号',
                    value:true
                },
                {
                    label:'样品名称',
                    value:true
                },
                {
                    label:'光源类型',
                    value:true
                },
                {
                    label:'标称功率(W)',
                    value:false
                },
                {
                    label:'标称电压(V)',
                    value:false
                },
                {
                    label:'标称色温(K/nm)',
                    value:false
                },
                {
                    label:'标称光束角',
                    value:false
                },
                {
                    label:'灯具尺寸(含支架mm)',
                    value:true
                },
                {
                    label:'灯具尺寸(不含支架mm)',
                    value:true
                },
                {
                    label:'检测模式',
                    value:true
                },
                {
                    label:'实测功率(W)',
                    value:true
                },
                {
                    label:'功率因数',
                    value:true
                },
                {
                    label:'实测电压(V)',
                    value:true
                },
                {
                    label:'实测光束角',
                    value:true
                },
                {
                    label:'实测色温(K/nm)',
                    value:true
                },
                {
                    label:'色容差(SDCM)',
                    value:true
                },
                {
                    label:'Ra',
                    value:true
                },
                {
                    label:'R9',
                    value:true
                },
                {
                    label:'光通量(lm)',
                    value:true
                },
                {
                    label:'峰值光强(cd)',
                    value:true
                },
                {
                    label:'0°(cd)',
                    value:true
                },
                {
                    label:'下10° 右60°(cd)',
                    value:true
                },
                {
                    label:'右60°(cd)',
                    value:true
                },
                {
                    label:'下45°(cd)',
                    value:true
                },
                {
                    label:'下60°(cd)',
                    value:true
                },
                {
                    label:'左60°(cd)',
                    value:true
                },
                {
                    label:'上30°(cd)',
                    value:true
                },
                {
                    label:'下10°(cd)',
                    value:true
                },
                {
                    label:'上60°(cd)',
                    value:true
                },
                {
                    label:'下10° 左60°(cd)',
                    value:true
                },
                {
                    label:'测试角度',
                    value:true
                },
                {
                    label:'含灯距离(m)',
                    value:false
                },
                {
                    label:'平均亮度(cd/㎡)',
                    value:true
                },
                {
                    label:'最大亮度(cd/㎡)',
                    value:true
                },
                {
                    label:'最小亮度(cd/㎡)',
                    value:true
                },
                {
                    label:'均匀度',
                    value:true
                },
                {
                    label:'暗斑高度(m)',
                    value:true
                },
                {
                    label:'IP等级',
                    value:true
                },
                {
                    label:'防盐雾',
                    value:true
                },
                {
                    label:'价格(元)',
                    value:false
                },
                ] 
            }else if(this.dian == 17 || this.dian == 29){
                this.columnShowHideList = [ 
                    {
                        label:'应用面类型',
                        value:true
                    },
                    {
                        label:'被照面信息',
                        value:true
                    },
                    {
                        label:'反射率',
                        value:true
                    },
                    {
                        label:'数据来源',
                        value:true
                    },
                    {
                        label:'品牌名称',
                        value:true
                    },
                    {
                        label:'灯具类型',
                        value:true
                    },
                    {
                        label:'设计编号',
                        value:true
                    },
                    {
                        label:'样品名称',
                        value:true
                    },
                    {
                        label:'光源类型',
                        value:true
                    },
                    {
                        label:'标称功率(W)',
                        value:false
                    },
                    {
                        label:'标称电压(V)',
                        value:false
                    },
                    {
                        label:'标称色温(K/nm)',
                        value:false
                    },
                    {
                        label:'标称光束角',
                        value:false
                    },
                    {
                        label:'灯具尺寸(含支架mm)',
                        value:true
                    },
                    {
                        label:'灯具尺寸(不含支架mm)',
                        value:true
                    },
                    {
                        label:'检测模式',
                        value:true
                    },
                    {
                        label:'实测功率(W)',
                        value:true
                    },
                    {
                        label:'功率因数',
                        value:true
                    },
                    {
                        label:'实测电压(V)',
                        value:true
                    },
                    {
                        label:'实测光束角',
                        value:true
                    },
                    {
                        label:'实测色温(K/nm)',
                        value:true
                    },
                    {
                        label:'色容差(SDCM)',
                        value:true
                    },
                    {
                        label:'Ra',
                        value:true
                    },
                    {
                        label:'R9',
                        value:true
                    },
                    {
                        label:'光通量(lm)',
                        value:true
                    },
                    {
                        label:'峰值光强(cd)',
                        value:true
                    },
                    {
                        label:'测试角度',
                        value:true
                    },
                    {
                        label:'含灯距离(m)',
                        value:true
                    },
                    {
                        label:'平均亮度(cd/㎡)',
                        value:true
                    },
                    {
                        label:'最大亮度(cd/㎡)',
                        value:true
                    },
                    {
                        label:'最小亮度(cd/㎡)',
                        value:true
                    },
                    {
                        label:'均匀度',
                        value:true
                    },
                    {
                        label:'暗斑高度(m)',
                        value:true
                    },
                    {
                        label:'IP等级',
                        value:true
                    },
                    {
                        label:'防盐雾',
                        value:true
                    },
                    {
                        label:'价格(元)',
                        value:false
                    },
                    {
                        label:'测试面(A/B)',
                        value:false
                    }
                ]
            }else{
                this.columnShowHideList = [ 
                    {
                        label:'应用面类型',
                        value:true
                    },
                    {
                        label:'被照面信息',
                        value:true
                    },
                    {
                        label:'反射率',
                        value:true
                    },
                    {
                        label:'数据来源',
                        value:true
                    },
                    {
                        label:'品牌名称',
                        value:true
                    },
                    {
                        label:'灯具类型',
                        value:true
                    },
                    {
                        label:'设计编号',
                        value:true
                    },
                    {
                        label:'样品名称',
                        value:true
                    },
                    {
                        label:'光源类型',
                        value:true
                    },
                    {
                        label:'标称功率(W)',
                        value:false
                    },
                    {
                        label:'标称电压(V)',
                        value:false
                    },
                    {
                        label:'标称色温(K/nm)',
                        value:false
                    },
                    {
                        label:'标称光束角',
                        value:false
                    },
                    {
                        label:'灯具尺寸(含支架mm)',
                        value:true
                    },
                    {
                        label:'灯具尺寸(不含支架mm)',
                        value:true
                    },
                    {
                        label:'检测模式',
                        value:true
                    },
                    {
                        label:'实测功率(W)',
                        value:true
                    },
                    {
                        label:'功率因数',
                        value:true
                    },
                    {
                        label:'实测电压(V)',
                        value:true
                    },
                    {
                        label:'实测光束角',
                        value:true
                    },
                    {
                        label:'实测色温(K/nm)',
                        value:true
                    },
                    {
                        label:'色容差(SDCM)',
                        value:true
                    },
                    {
                        label:'Ra',
                        value:true
                    },
                    {
                        label:'R9',
                        value:true
                    },
                    {
                        label:'光通量(lm)',
                        value:true
                    },
                    {
                        label:'峰值光强(cd)',
                        value:true
                    },
                    {
                        label:'测试角度',
                        value:true
                    },
                    {
                        label:'含灯距离(m)',
                        value:true
                    },
                    {
                        label:'平均亮度(cd/㎡)',
                        value:true
                    },
                    {
                        label:'最大亮度(cd/㎡)',
                        value:true
                    },
                    {
                        label:'最小亮度(cd/㎡)',
                        value:true
                    },
                    {
                        label:'均匀度',
                        value:true
                    },
                    {
                        label:'暗斑高度(m)',
                        value:true
                    },
                    {
                        label:'IP等级',
                        value:true
                    },
                    {
                        label:'防盐雾',
                        value:true
                    },
                    {
                        label:'价格(元)',
                        value:false
                    }
                ]  
            }
        },
        checkBiaocheng(){
            if(this.dian == 31){
                this.columnShowHideList = [ 
                    {
                        label:'应用面类型',
                        value:true
                    },
                    {
                        label:'被照面信息',
                        value:true
                    },
                    {
                        label:'反射率',
                        value:true
                    },
                    {
                        label:'数据来源',
                        value:true
                    },
                    {
                        label:'品牌名称',
                        value:true
                    },
                    {
                        label:'灯具类型',
                        value:true
                    },
                    {
                        label:'设计编号',
                        value:true
                    },
                    {
                        label:'样品名称',
                        value:true
                    },
                    {
                        label:'光源类型',
                        value:true
                    },
                    {
                        label:'标称功率(W)',
                        value:true
                    },
                    {
                        label:'标称电压(V)',
                        value:true
                    },
                    {
                        label:'标称色温(K/nm)',
                        value:true
                    },
                    {
                        label:'标称光束角',
                        value:true
                    },
                    {
                        label:'灯具尺寸(含支架mm)',
                        value:false
                    },
                    {
                        label:'灯具尺寸(不含支架mm)',
                        value:false
                    },
                    {
                        label:'检测模式',
                        value:false
                    },
                    {
                        label:'实测功率(W)',
                        value:false
                    },
                    {
                        label:'功率因数',
                        value:false
                    },
                    {
                        label:'实测电压(V)',
                        value:false
                    },
                    {
                        label:'实测光束角',
                        value:false
                    },
                    {
                        label:'实测色温(K/nm)',
                        value:false
                    },
                    {
                        label:'色容差(SDCM)',
                        value:false
                    },
                    {
                        label:'Ra',
                        value:false
                    },
                    {
                        label:'R9',
                        value:false
                    },
                    {
                        label:'光通量(lm)',
                        value:false
                    },
                    {
                        label:'峰值光强(cd)',
                        value:false
                    },
                    {
                        label:'测试角度',
                        value:false
                    },
                    {
                        label:'含灯距离(m)',
                        value:false
                    },
                    {
                        label:'平均亮度(cd/㎡)',
                        value:false
                    },
                    {
                        label:'最大亮度(cd/㎡)',
                        value:false
                    },
                    {
                        label:'最小亮度(cd/㎡)',
                        value:false
                    },
                    {
                        label:'均匀度',
                        value:false
                    },
                    {
                        label:'暗斑高度(m)',
                        value:false
                    },
                    {
                        label:'IP等级',
                        value:false
                    },
                    {
                        label:'防盐雾',
                        value:false
                    },
                    {
                        label:'价格(元)',
                        value:false
                    }
                ]
            }else if(this.dian == 17 || this.dian == 29){
                this.columnShowHideList = [
                    {
                        label:'应用面类型',
                        value:true
                    },
                    {
                        label:'被照面信息',
                        value:true
                    },
                    {
                        label:'反射率',
                        value:true
                    },
                    {
                        label:'数据来源',
                        value:true
                    },
                    {
                        label:'品牌名称',
                        value:true
                    },
                    {
                        label:'灯具类型',
                        value:true
                    },
                    {
                        label:'设计编号',
                        value:true
                    },
                    {
                        label:'样品名称',
                        value:true
                    },
                    {
                        label:'光源类型',
                        value:true
                    },
                    {
                        label:'标称功率(W)',
                        value:true
                    },
                    {
                        label:'标称电压(V)',
                        value:true
                    },
                    {
                        label:'标称色温(K/nm)',
                        value:true
                    },
                    {
                        label:'标称光束角',
                        value:true
                    },
                    {
                        label:'灯具尺寸(含支架mm)',
                        value:false
                    },
                    {
                        label:'灯具尺寸(不含支架mm)',
                        value:false
                    },
                    {
                        label:'检测模式',
                        value:false
                    },
                    {
                        label:'实测功率(W)',
                        value:false
                    },
                    {
                        label:'功率因数',
                        value:false
                    },
                    {
                        label:'实测电压(V)',
                        value:false
                    },
                    {
                        label:'实测光束角',
                        value:false
                    },
                    {
                        label:'实测色温(K/nm)',
                        value:false
                    },
                    {
                        label:'色容差(SDCM)',
                        value:false
                    },
                    {
                        label:'Ra',
                        value:false
                    },
                    {
                        label:'R9',
                        value:false
                    },
                    {
                        label:'光通量(lm)',
                        value:false
                    },
                    {
                        label:'峰值光强(cd)',
                        value:false
                    },
                    {
                        label:'0°(cd)',
                        value:false
                    },
                    {
                        label:'下10° 右60°(cd)',
                        value:false
                    },
                    {
                        label:'右60°(cd)',
                        value:false
                    },
                    {
                        label:'下45°(cd)',
                        value:false
                    },
                    {
                        label:'下60°(cd)',
                        value:false
                    },
                    {
                        label:'左60°(cd)',
                        value:false
                    },
                    {
                        label:'上30°(cd)',
                        value:false
                    },
                    {
                        label:'下10°(cd)',
                        value:false
                    },
                    {
                        label:'上60°(cd)',
                        value:false
                    },
                    {
                        label:'下10° 左60°(cd)',
                        value:false
                    },
                    {
                        label:'测试角度',
                        value:false
                    },
                    {
                        label:'含灯距离(m)',
                        value:false
                    },
                    {
                        label:'平均亮度(cd/㎡)',
                        value:false
                    },
                    {
                        label:'最大亮度(cd/㎡)',
                        value:false
                    },
                    {
                        label:'最小亮度(cd/㎡)',
                        value:false
                    },
                    {
                        label:'均匀度',
                        value:false
                    },
                    {
                        label:'暗斑高度(m)',
                        value:false
                    },
                    {
                        label:'IP等级',
                        value:false
                    },
                    {
                        label:'防盐雾',
                        value:false
                    },
                    {
                        label:'价格(元)',
                        value:true
                    },
                    {
                        label:'测试面(A/B)',
                        value:false
                    },
                ]
            }else{
                this.columnShowHideList = [
                    {
                        label:'应用面类型',
                        value:true
                    },
                    {
                        label:'被照面信息',
                        value:true
                    },
                    {
                        label:'反射率',
                        value:true
                    },
                    {
                        label:'数据来源',
                        value:true
                    },
                    {
                        label:'品牌名称',
                        value:true
                    },
                    {
                        label:'灯具类型',
                        value:true
                    },
                    {
                        label:'设计编号',
                        value:true
                    },
                    {
                        label:'样品名称',
                        value:true
                    },
                    {
                        label:'光源类型',
                        value:true
                    },
                    {
                        label:'标称功率(W)',
                        value:true
                    },
                    {
                        label:'标称电压(V)',
                        value:true
                    },
                    {
                        label:'标称色温(K/nm)',
                        value:true
                    },
                    {
                        label:'标称光束角',
                        value:true
                    },
                    {
                        label:'灯具尺寸(含支架mm)',
                        value:false
                    },
                    {
                        label:'灯具尺寸(不含支架mm)',
                        value:false
                    },
                    {
                        label:'检测模式',
                        value:false
                    },
                    {
                        label:'实测功率(W)',
                        value:false
                    },
                    {
                        label:'功率因数',
                        value:false
                    },
                    {
                        label:'实测电压(V)',
                        value:false
                    },
                    {
                        label:'实测光束角',
                        value:false
                    },
                    {
                        label:'实测色温(K/nm)',
                        value:false
                    },
                    {
                        label:'色容差(SDCM)',
                        value:false
                    },
                    {
                        label:'Ra',
                        value:false
                    },
                    {
                        label:'R9',
                        value:false
                    },
                    {
                        label:'光通量(lm)',
                        value:false
                    },
                    {
                        label:'峰值光强(cd)',
                        value:false
                    },
                    {
                        label:'0°(cd)',
                        value:false
                    },
                    {
                        label:'下10° 右60°(cd)',
                        value:false
                    },
                    {
                        label:'右60°(cd)',
                        value:false
                    },
                    {
                        label:'下45°(cd)',
                        value:false
                    },
                    {
                        label:'下60°(cd)',
                        value:false
                    },
                    {
                        label:'左60°(cd)',
                        value:false
                    },
                    {
                        label:'上30°(cd)',
                        value:false
                    },
                    {
                        label:'下10°(cd)',
                        value:false
                    },
                    {
                        label:'上60°(cd)',
                        value:false
                    },
                    {
                        label:'下10° 左60°(cd)',
                        value:false
                    },
                    {
                        label:'测试角度',
                        value:false
                    },
                    {
                        label:'含灯距离(m)',
                        value:false
                    },
                    {
                        label:'平均亮度(cd/㎡)',
                        value:false
                    },
                    {
                        label:'最大亮度(cd/㎡)',
                        value:false
                    },
                    {
                        label:'最小亮度(cd/㎡)',
                        value:false
                    },
                    {
                        label:'均匀度',
                        value:false
                    },
                    {
                        label:'暗斑高度(m)',
                        value:false
                    },
                    {
                        label:'IP等级',
                        value:false
                    },
                    {
                        label:'防盐雾',
                        value:false
                    },
                    {
                        label:'价格(元)',
                        value:true
                    },
                ]
            }
        },
        initData(){
            this.dian = this.$route.query.dian
            var ids = this.$route.query.ids
            if(ids.length > 0){
                ids = ids.substring(0,ids.length -1)
            }
            var ab = "A"
            if(this.checkab){
                ab = "B"
            }
            let self =this
            this.$http.post('/api/contests/compList',{detectionIds:ids},function(res){
                if(self.dian == 17 || self.dian==29){
                    var temp = []
                    for(var i = 0;i<res.data.length;i++){
                        if(res.data[i].surfaceType == ab){
                            temp.push(res.data[i])
                        }
                    }
                    self.tableData = temp
                }else{
                    self.tableData = res.data
                }
                if(self.tableData.length <6){
                    for(var i =self.tableData.length;i<6;i++){
                        self.tableData.push({
                            isFalse:true
                        })
                    }
                }
            })
            this.checkAll();
        },
        hideXiangTong(){
            for(var i = 0;i<this.columnShowHideList.length;i++){
                this.columnShowHideList[i].value = false
                // this.$set(this.columnShowHideList,i,this.columnShowHideList[i]);
            }
            // console.log(this.columnShowHideList[0].value)
            
            for(var i = 0;i<this.tableData.length;i++){
                if(i == 0 || this.tableData[i].isFalse){
                    continue;
                }
                if(this.columnShowHideList[0].value == false && this.tableData[i].contestTypeStr != this.tableData[0].contestTypeStr){
                    this.columnShowHideList[0].value = true
                }
                if(this.columnShowHideList[1].value == false && this.tableData[i].faceInfo != this.tableData[0].faceInfo){
                    this.columnShowHideList[1].value = true
                }
                if(this.columnShowHideList[2].value == false && this.tableData[i].albedo != this.tableData[0].albedo){
                    this.columnShowHideList[2].value = true
                }
                if(this.columnShowHideList[3].value == false && this.tableData[i].datatype != this.tableData[0].datatype){
                    this.columnShowHideList[3].value = true
                }
                if(this.columnShowHideList[4].value == false && this.tableData[i].brandName != this.tableData[0].brandName){
                    this.columnShowHideList[4].value = true
                }
                if(this.columnShowHideList[5].value == false && this.tableData[i].dictIdLtype != this.tableData[0].dictIdLtype){
                    this.columnShowHideList[5].value = true
                }
                if(this.columnShowHideList[6].value == false && this.tableData[i].designCode != this.tableData[0].designCode){
                    this.columnShowHideList[6].value = true
                }
                if(this.columnShowHideList[7].value == false && this.tableData[i].lumName != this.tableData[0].lumName){
                    this.columnShowHideList[7].value = true
                }
                if(this.columnShowHideList[8].value == false && this.tableData[i].dictIdLitype != this.tableData[0].dictIdLitype){
                    this.columnShowHideList[8].value = true
                }
                if(this.columnShowHideList[9].value == false && this.tableData[i].lumPower != this.tableData[0].lumPower){
                    this.columnShowHideList[9].value = true
                }
                if(this.columnShowHideList[10].value == false && this.tableData[i].lumVoltage != this.tableData[0].lumVoltage){
                    this.columnShowHideList[10].value = true
                }
                if(this.columnShowHideList[11].value == false && this.tableData[i].lumColorTempe != this.tableData[0].lumColorTempe){
                    this.columnShowHideList[11].value = true
                }
                if(this.columnShowHideList[12].value == false && this.tableData[i].lumAngle != this.tableData[0].lumAngle){
                    this.columnShowHideList[12].value = true
                }
                if(this.columnShowHideList[13].value == false && this.tableData[i].longS != this.tableData[0].longS){
                    this.columnShowHideList[13].value = true
                }
                if(this.columnShowHideList[14].value == false && this.tableData[i].longNs != this.tableData[0].longNs){
                    this.columnShowHideList[14].value = true
                }
                if(this.columnShowHideList[15].value == false && this.tableData[i].rgbwa != this.tableData[0].rgbwa){
                    this.columnShowHideList[15].value = true
                }
                if(this.columnShowHideList[16].value == false && this.tableData[i].power != this.tableData[0].power){
                    this.columnShowHideList[16].value = true
                }
                if(this.columnShowHideList[17].value == false && this.tableData[i].powerFactor != this.tableData[0].powerFactor){
                    this.columnShowHideList[17].value = true
                }
                if(this.columnShowHideList[18].value == false && this.tableData[i].voltage != this.tableData[0].voltage){
                    this.columnShowHideList[18].value = true
                }
                if(this.columnShowHideList[19].value == false && this.tableData[i].angle1 != this.tableData[0].angle1){
                    this.columnShowHideList[19].value = true
                }
                if(this.columnShowHideList[20].value == false && this.tableData[i].colorTempe != this.tableData[0].colorTempe){
                    this.columnShowHideList[20].value = true
                }
                if(this.columnShowHideList[21].value == false && this.tableData[i].sdcm != this.tableData[0].sdcm){
                    this.columnShowHideList[21].value = true
                }
                if(this.columnShowHideList[22].value == false && this.tableData[i].colorXszs != this.tableData[0].colorXszs){
                    this.columnShowHideList[22].value = true
                }
                if(this.columnShowHideList[23].value == false && this.tableData[i].colorXszsR9 != this.tableData[0].colorXszsR9){
                    this.columnShowHideList[23].value = true
                }
                if(this.columnShowHideList[24].value == false && this.tableData[i].opticGtl != this.tableData[0].opticGtl){
                    this.columnShowHideList[24].value = true
                }
                if(this.columnShowHideList[25].value == false && this.tableData[i].lightFzgq != this.tableData[0].lightFzgq){
                    this.columnShowHideList[25].value = true
                }
            if(this.dian == 31){
                if(this.columnShowHideList[26].value == false && this.tableData[i].lightIntensity1 != this.tableData[0].lightIntensity1){
                    this.columnShowHideList[26].value = true
                }
                if(this.columnShowHideList[27].value == false && this.tableData[i].lightIntensity10 != this.tableData[0].lightIntensity10){
                    this.columnShowHideList[27].value = true
                }
                if(this.columnShowHideList[28].value == false && this.tableData[i].lightIntensity2 != this.tableData[0].lightIntensity2){
                    this.columnShowHideList[28].value = true
                }
                if(this.columnShowHideList[29].value == false && this.tableData[i].lightIntensity3 != this.tableData[0].lightIntensity3){
                    this.columnShowHideList[29].value = true
                }
                if(this.columnShowHideList[30].value == false && this.tableData[i].lightIntensity4 != this.tableData[0].lightIntensity4){
                    this.columnShowHideList[30].value = true
                }
                if(this.columnShowHideList[31].value == false && this.tableData[i].lightIntensity5 != this.tableData[0].lightIntensity5){
                    this.columnShowHideList[31].value = true
                }
                if(this.columnShowHideList[32].value == false && this.tableData[i].lightIntensity6 != this.tableData[0].lightIntensity6){
                    this.columnShowHideList[32].value = true
                }
                if(this.columnShowHideList[33].value == false && this.tableData[i].lightIntensity7 != this.tableData[0].lightIntensity7){
                    this.columnShowHideList[33].value = true
                }
                if(this.columnShowHideList[34].value == false && this.tableData[i].lightIntensity8 != this.tableData[0].lightIntensity8){
                    this.columnShowHideList[34].value = true
                }
                if(this.columnShowHideList[35].value == false && this.tableData[i].lightIntensity9 != this.tableData[0].lightIntensity9){
                    this.columnShowHideList[35].value = true
                }
                if(this.columnShowHideList[36].value == false && this.tableData[i].testAngle != this.tableData[0].testAngle){
                    this.columnShowHideList[36].value = true
                }
                if(this.columnShowHideList[37].value == false && this.tableData[i].lumSize != this.tableData[0].lumSize){
                    this.columnShowHideList[37].value = true
                }
                if(this.columnShowHideList[38].value == false && this.tableData[i].lightnessAve != this.tableData[0].lightnessAve){
                    this.columnShowHideList[38].value = true
                }
                if(this.columnShowHideList[39].value == false && this.tableData[i].lightnessMax != this.tableData[0].lightnessMax){
                    this.columnShowHideList[39].value = true
                }
                if(this.columnShowHideList[40].value == false && this.tableData[i].lightness != this.tableData[0].lightness){
                    this.columnShowHideList[40].value = true
                }
                if(this.columnShowHideList[41].value == false && this.tableData[i].evenness != this.tableData[0].evenness){
                    this.columnShowHideList[41].value = true
                }
                if(this.columnShowHideList[42].value == false && this.tableData[i].anbanHeight != this.tableData[0].anbanHeight){
                    this.columnShowHideList[42].value = true
                }
                if(this.columnShowHideList[43].value == false && this.tableData[i].anWater != this.tableData[0].anWater){
                    this.columnShowHideList[43].value = true
                }
                if(this.columnShowHideList[44].value == false && this.tableData[i].anSaltfog != this.tableData[0].anSaltfog){
                    this.columnShowHideList[44].value = true
                }
                if(this.columnShowHideList[45].value == false && this.tableData[i].authorizedPrice != this.tableData[0].authorizedPrice){
                    this.columnShowHideList[45].value = true
                }
            }else if(this.dian==17 || this.dian == 29){
                if(this.columnShowHideList[26].value == false && this.tableData[i].testAngle != this.tableData[0].testAngle){
                    this.columnShowHideList[26].value = true
                }
                if(this.columnShowHideList[27].value == false && this.tableData[i].lumSize != this.tableData[0].lumSize){
                    this.columnShowHideList[27].value = true
                }
                if(this.columnShowHideList[28].value == false && this.tableData[i].lightnessAve != this.tableData[0].lightnessAve){
                    this.columnShowHideList[28].value = true
                }
                if(this.columnShowHideList[29].value == false && this.tableData[i].lightnessMax != this.tableData[0].lightnessMax){
                    this.columnShowHideList[29].value = true
                }
                if(this.columnShowHideList[30].value == false && this.tableData[i].lightness != this.tableData[0].lightness){
                    this.columnShowHideList[30].value = true
                }
                if(this.columnShowHideList[31].value == false && this.tableData[i].evenness != this.tableData[0].evenness){
                    this.columnShowHideList[31].value = true
                }
                if(this.columnShowHideList[32].value == false && this.tableData[i].anbanHeight != this.tableData[0].anbanHeight){
                    this.columnShowHideList[32].value = true
                }
                if(this.columnShowHideList[33].value == false && this.tableData[i].anWater != this.tableData[0].anWater){
                    this.columnShowHideList[33].value = true
                }
                if(this.columnShowHideList[34].value == false && this.tableData[i].anSaltfog != this.tableData[0].anSaltfog){
                    this.columnShowHideList[34].value = true
                }
                if(this.columnShowHideList[35].value == false && this.tableData[i].authorizedPrice != this.tableData[0].authorizedPrice){
                    this.columnShowHideList[35].value = true
                }
                if(this.columnShowHideList[36].value == false && this.tableData[i].surfaceType != this.tableData[0].surfaceType){
                    this.columnShowHideList[36].value = true
                }
            }else{
                if(this.columnShowHideList[26].value == false && this.tableData[i].testAngle != this.tableData[0].testAngle){
                    this.columnShowHideList[26].value = true
                }
                if(this.columnShowHideList[27].value == false && this.tableData[i].lumSize != this.tableData[0].lumSize){
                    this.columnShowHideList[27].value = true
                }
                if(this.columnShowHideList[28].value == false && this.tableData[i].lightnessAve != this.tableData[0].lightnessAve){
                    this.columnShowHideList[28].value = true
                }
                if(this.columnShowHideList[29].value == false && this.tableData[i].lightnessMax != this.tableData[0].lightnessMax){
                    this.columnShowHideList[29].value = true
                }
                if(this.columnShowHideList[30].value == false && this.tableData[i].lightness != this.tableData[0].lightness){
                    this.columnShowHideList[30].value = true
                }
                if(this.columnShowHideList[31].value == false && this.tableData[i].evenness != this.tableData[0].evenness){
                    this.columnShowHideList[31].value = true
                }
                if(this.columnShowHideList[32].value == false && this.tableData[i].anbanHeight != this.tableData[0].anbanHeight){
                    this.columnShowHideList[32].value = true
                }
                if(this.columnShowHideList[33].value == false && this.tableData[i].anWater != this.tableData[0].anWater){
                    this.columnShowHideList[33].value = true
                }
                if(this.columnShowHideList[34].value == false && this.tableData[i].anSaltfog != this.tableData[0].anSaltfog){
                    this.columnShowHideList[34].value = true
                }
                if(this.columnShowHideList[35].value == false && this.tableData[i].authorizedPrice != this.tableData[0].authorizedPrice){
                    this.columnShowHideList[35].value = true
                }
            }
            }
            this.radio = ''
            // this.detailsShow = true
        },
        changeColumnSH(index,item){
            this.columnShowHideList[index].value = !item.value
        },
        back(){
            history.back()
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss">
.details .box80 .details_l .details_l_t button.fanhuo{
    margin-bottom: 10px;
}
.details .box80 .details_l .details_l_t button.fanhuo span{
        width: 18px;
    height: 18px;
    text-align: center;
    line-height: 19px;
    border-radius: 50%;
    border: 1px solid #fff;
    display: inline-block;
    position: relative;
    cursor: pointer;
    top:2px;
    margin-right: 9px;
}
.details-class {
    padding: 0;
    .contcheck {
        width: 770px;
        padding: 5%;
        .ser{
            overflow: hidden;
            margin: 12px
        }
        .li_list {
            width: 25%;
            float: left;
            margin-right: 0;
                input {
                position: relative;
                top: 2px;
                margin-right: 3px;
            }
        }
    }
    .tp {
        background-color: #5a63a3;
        color: #fff;
        padding: 15px 25px;
    }
    .el-icon-error {
        color: #fff;
        font-size: 20px;
    }
    .btn {
        .el-button--primary{
             padding: 7px 25px;
                background-color: #5a63a3;
                border-radius: 4px;
                border: none;
        }
    }
}
.details{
    background: #f4f4fd;
    box-shadow: none;
    .box80{
        .wid100{
            box-shadow: 7px 6px 10px 0px rgba(90, 99, 163, 0.06);
        }
        padding: 120px 0 50px;
        .details_l{
            width: 14.2857%;
            float: left;
            .details_l_t{
                background-color: #5962a3;
                box-shadow: 1px 1px 10px 0px #f6f6f6;
                border-radius: 4px;
                height: 326px;
                .cont{
                    padding: 20px 20px 10px;
                    .el-checkbox__label{
                        color:#fff;
                    }
                    .list_S{
                        .el-button{padding: 0;}
                    }
                    .tab{
                        span{
                            font-size: 16px;
                            color: #fff;
                        }
                        img{
                            display: inline-block;
                            margin-left: 10px;
                            position: relative;
                            top: 4px;
                        }
                    }
                }
                .xian{
                    background-color: rgba(238, 238, 238, 0.3);
                    height: 2px;
                }
                button{
                    color: #fff;
                    border: none;
                    background: none;
                    font-size: 16px;
                    margin-bottom: 15px;
                    img{
                        margin-right: 6px;
                        margin-left: 0;
                        position: relative;
                        top: 3px;
                        display: inline-block;
                    }
                }
                .el-radio{
                    color: #fff;  
                    margin-bottom: 15px;
                    &:last-child{
                        margin-bottom: 0;
                    }             
                    .el-radio__inner{
                        border: 1px solid #fff;
                        background: none;
                    }  
                    .el-radio__input.is-checked .el-radio__inner{
                        border-color:#fff;
                        background: none;
                        &:after{
                           width: 6px;
                           height: 6px;
                        }
                    }
                    .el-radio__label{
                        font-size: 16px;
                        color: #fff !important;
                    }
                }
                .el-radio__input.is-checked+.el-radio__label{
                    color: #fff;
                }
            }
            .details_l_b{
                margin-top: 20px;
                background-color: #5962a3;
                box-shadow: 1px 1px 10px 0px #f6f6f6;
                border-radius: 4px;
                ul li{
                    text-align: center;
                    color: #fff;
                     padding: 18px 5px;
                     height: 60px;
                    &:nth-child(even){
                        background-color: rgba(246, 247, 251, 0.1);
                    }
                }
            }
        }
        .details_r{
            width: 85.7143%;
            float: left;
            .details_r_list{
                width: 16.666%;
                float: left;
                text-align: center;
                position: relative;
                &:hover::before{
                    content: '';
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    background-color: rgba(89, 98, 163, 0.4)
                }
                .details_r_t{
                    background: #fff;
                    padding: 20px;
                    height: 326px;
                    border-left: 1px solid #eeeeee;
                    .conts{
                        position: relative;
                        height: 100%;
                        .imhs{
                            max-width: 100%;
                            max-height: 100%;
                        }
                        .control{
                            position: absolute;
                            background-color: #eeeeee;
                            box-shadow: 2px 2px 14px 0px rgba(0, 0, 0, 0.6);
                            border-radius: 4px;
                            top: 10px;
                            left: 50%;
                            transform:translateX(-50%);
                            padding: 8px 10px 2px;
                            cursor: pointer;
                            width: 100px;
                            img{
                                margin-left: 6px;
                                box-shadow: 0px 0px 5px 0px #dadada;
                                    border-radius: 50%;
                                    display: inline-block;
                                &:first-child{
                                    margin-left: 0;
                                }
                            }
                        }
                    }
                }
                .details_r_b{
                    margin-top: 20px;
                    li{
                        padding: 18px 5px;
                        height: 60px;
                        background: #fff;
                        border-left: 1px solid #eeeeee;
                        &:nth-child(even) {
                            background-color: rgba(246, 247, 251, 0.1);
                        }
                    }
                }
            }
        }
    }
}
@media (max-width:1500px){
    .details{
        .box80 .details_l .details_l_t{
            button{
                font-size: 14px;
            }
            .el-radio .el-radio__label{
                font-size: 14px;
            }
        } 
    }
    .details .box80 .details_l .details_l_t .cont .tab span{font-size: 12px;}
}
@media (max-width:1330px){
    .details .box80 .details_l .details_l_t{
         .cont{
             padding: 20px 12px;
        }
    }
}
</style>


